<template>
  <!-- Fixed height only from md up: there the logo banner is absolutely placed over
       the video. On phones the banner sits below the video in normal flow, so the
       section must grow to contain it (a fixed 519px made it overlap the next
       section's heading). -->
  <section
    class="relative bg-[url('../public/images/IntroVideo/Slider-BG.jpg')] bg-cover bg-center md:h-[519px] font-electro text-lg"
  >
    <video
      class="m-auto h-[519px] w-[1200px] object-cover"
      autoplay
      muted
      playsinline
      loop
      loading="lazy"
      preload="metadata"
      poster="images/IntroVideo/Slider-BG.jpg"
    >
      <source
        src="/videos/videoplayback-2.mp4"
        type="video/mp4"
      />
    </video>

    <section class="hidden xl:block absolute top-20 left-28 w-full">
      <div class="relative">
        <picture class="contents">
          <source srcset="/images/IntroVideo/roadbook-cross-country.webp" type="image/webp" />
          <img
          decoding="async"
          fetchpriority="high"
          width="300"
          height="125"
          src="/images/IntroVideo/roadbook-cross-country.png"
          class="absolute -rotate-12 m-auto shadow-black shadow-2xl"
          />
        </picture>
        <picture class="contents">
          <source srcset="/images/IntroVideo/funnel-bike.webp" type="image/webp" />
          <img
          decoding="async"
          fetchpriority="high"
          width="350"
          height="200"
          src="/images/IntroVideo/funnel-bike.png"
          class="absolute rotate-12 m-auto -left-24 top-4"
          />
        </picture>
      </div>
    </section>
    <section class="hidden xl:block absolute top-24 w-full">
      <div class="relative w-full">
        <picture class="contents">
          <source srcset="/images/IntroVideo/Road-Rally-Home-Page-image-1.webp" type="image/webp" />
          <img
          decoding="async"
          fetchpriority="high"
          width="300"
          height="125"
          src="/images/IntroVideo/Road-Rally-Home-Page-image-1.png"
          class="absolute rotate-12 m-auto shadow-black shadow-2xl right-16"
          />
        </picture>
        <picture class="contents">
          <source srcset="/images/IntroVideo/funnel-car.webp" type="image/webp" />
          <img
          decoding="async"
          fetchpriority="high"
          width="400"
          height="200"
          src="/images/IntroVideo/funnel-car.png"
          class="absolute -rotate-12 m-auto top-24 right-0"
          />
        </picture>
      </div>
    </section>
    <section class="md:absolute md:bottom-12 grid grid-cols-12 w-full">
      <div
        class="bg-[#000000CC] col-span-12 md:col-span-7 pb-3 pt-16 relative md:logoShadow"
      >
        <picture class="contents">
          <source srcset="/images/IntroVideo/logo-darkshadow.webp" type="image/webp" />
          <img
          decoding="async"
          fetchpriority="high"
          width="441"
          height="132"
          src="/images/IntroVideo/logo-darkshadow.png"
          class="m-auto absolute -top-7 xl:-top-10 left-1/2 -translate-x-1/2 h-24 xl:h-auto w-auto"
          />
        </picture>
        <h2 class="text-white font-bold text-xl xl:text-2xl mt-0 xl:mt-2">
          RALLY ROADBOOK SYSTEM
        </h2>
      </div>
    </section>
  </section>
</template>

<script>
export default {
  name: 'IntroVideo',
};
</script>

<style scoped>
.logoShadow {
  clip-path: polygon(0 -18px, 100% -50%, 80% 100%, 0% 100%);
}
</style>
